import { BookingData } from "../models/bookingData";

const date = new Date()
export const searchBookingInitial: BookingData = {
    Booking: {
      Id: 0,
      VehicleId: 0,
      CustomerId: 0,
      AppointmentId: 0,
      StatusCode: 0,
      BookingSource: undefined,
      CustomerRelationship: undefined,
      ServiceAdvisorId: undefined,
      DmsBookingId: undefined,
      DmsBookingKey: -1,
      CreationTimestamp: date,
      ReservationToken: '',
      IsSendConfirmationBooking: false,
      IsSendSmsConfirmationBooking: false,
      IsConsentConfirmationBooking: false,
      CustomerComment: '',
      IdPrefix: '',
      Customer: undefined,
      Driver: undefined,
      Vehicle: undefined,
      Appointment: undefined,
      Jobs: [],
      ServiceAdvisor: null,
      OwnedVehicles: [],
      AdvisorTimeslotBooking: undefined
    },
    IsFromDMS: false,
    AllBookings: [],
    Customers: []
  }